import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.unit-group.uz',
});

// Helper function to properly stringify nested objects in FormData
const stringifyNestedObjects = (data) => {
  const formData = new FormData();
  
  Object.entries(data).forEach(([key, value]) => {
    if (value instanceof File || value instanceof Blob) {
      formData.append(key, value);
    } else if (typeof value === 'object' && value !== null) {
      // Special handling for variants_data
      if (key === 'variants_data') {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, JSON.stringify(value));
      }
    } else {
      formData.append(key, value);
    }
  });
  
  return formData;
};

export const setupAxiosInterceptors = (token, onUnauthorized) => {
  api.interceptors.request.use((config) => {
    // Handle FormData requests
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    } else if (typeof config.data === 'object' && config.data !== null) {
      // Convert nested objects to FormData when needed
      config.data = stringifyNestedObjects(config.data);
      config.headers['Content-Type'] = 'multipart/form-data';
    } else {
      config.headers['Content-Type'] = 'application/json';
    }

    // Add authorization token
    if (token) {
      const accessToken = typeof token === 'object' ? token.access : token;
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
    }
    
    return config;
  });

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        onUnauthorized?.();
      }
      
      // Improved error logging for debugging
      if (error.response) {
        console.error('API Error Response:', {
          status: error.response.status,
          data: error.response.data,
          headers: error.response.headers,
          request: error.config.data
            ? JSON.parse(JSON.stringify(error.config.data))
            : error.config.data
        });
      }
      
      return Promise.reject(error);
    }
  );
};

export default api;